module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "page-content-wrapper"
  }, [_c('div', {
    staticClass: "page-content hello"
  }, [_c('div', {
    staticClass: "page-bar"
  }, [_c('ul', {
    staticClass: "page-breadcrumb"
  }, [_c('li', [_c('i', {
    staticClass: "fa fa-home"
  }), _vm._v(" "), _c('a', {
    attrs: {
      "href": "index.html"
    }
  }, [_vm._v("首页")]), _vm._v(" "), _c('i', {
    staticClass: "fa fa-angle-right"
  })]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("test")])])])]), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "sel"
  }, [_c('select', [_c('option', [_vm._v("Select dropdown")]), _vm._v(" "), _c('option', [_vm._v("With options")])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-5622ce64!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/TestBulma.vue
// module id = 304
// module chunks = 2 3